import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsPolicy } from "../types";

const SpaceDetailsPoliciesDescriptionCell = ({
  item: policy,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsPolicy>) => (
  <TableSimpleCell {...cellProps}>
    <TableCellDescription description={policy.description} />
  </TableSimpleCell>
);

export default SpaceDetailsPoliciesDescriptionCell;
